import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Injectable, OnDestroy } from '@angular/core';
import { BaseRestService } from './base-rest.service';
import { IOnlineReportSettingList, OnlineReportSetting } from '../models/online-reporting-setting';
import { forkJoin, Observable, of, Subscription } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { OrganisationService } from './organisation.service';
import { SubjectTypeService } from './subject-type.service';
import { AutoUnsubscribe } from 'auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Injectable({ providedIn: 'root'})
export class OnlineReportSettingService extends BaseRestService<OnlineReportSetting, IOnlineReportSettingList> implements OnDestroy{

  public FILEACONCERN = 'File A Concern';
  
  organisationSaved: Subscription;
  organisationDeleted: Subscription;

  constructor(http: HttpClient, protected router: Router, private organisationService: OrganisationService, private subjectTypeService: SubjectTypeService) {
    super(OnlineReportSettingService, http, 'api/onlinereportsettings', 'online report setting', router);

    // enable caching
    this.cacheEnabled = true;

    this.organisationSaved = this.organisationService.onAfterSave.subscribe((_) => {
      this.clearCache();
    });

    this.organisationDeleted = this.organisationService.onDeleted.subscribe((_) => {
      this.clearCache();
    });
  }

  ngOnDestroy(){
    this.organisationSaved?.unsubscribe();
    this.organisationDeleted?.unsubscribe();
  }

  afterSave(entity) {
    // ... now re-fetch subject type data
    // performance would be slightly better if we just refresh the subject type data for the current referral subject type
    // however this gets slightly messy with circular references/events
    // the subject type data is relatively small so isn't going to be a big performance issue re-fetching it all
    this.subjectTypeService.refresh();
  }

  hydrate(item: OnlineReportSetting): Observable<OnlineReportSetting> {
    const hydrate$ = [];
    if ((item.organisationId && (!item.organisation)) || (item.organisation && (item.organisation.id !== item.organisationId))){
      hydrate$.push(this.organisationService.getById(item.organisationId).pipe(take(1), map((organisation) => {
        item.organisation = organisation;
        return item;
      })));
    }

    if (hydrate$.length > 0){
      return forkJoin(hydrate$).pipe(take(1), map((_) => {
        return item;
      }));
    }
    else{
      return of(item);
    }
  }
}
